import { CopyProperties } from 'src/app/shared/decorator/copy-properties.decorator';
import { ProductInfo } from 'src/app/modules/product/models/product.info.model';

@CopyProperties()
export class Product {
  id: number;
  code: string;
  name: string;
  nameEn: string;
  shortName: string;
  price: number;
  vsdFeeId: any;
  approveAt: any;
  releaseAt: any;
  expireAt: any;
  closeAt: any;
  buyMin: any;
  buyMax: any;
  sellMin: any;
  transferSellMin : any;
  inStock: any;
  releaseVolume: any;
  website: any;
  firebaseKey: any;
  createAt: any;
  updateAt: any;
  productInfo: ProductInfo;
  productFund: any;
  currencyCode: any;
  statusCode: any;
  typeCode: any;
  countryCode: any;
  productFeeList: any;
  extra: any;
  featured: any;
  bankAccount: any;
  feeBuys: any;
  feeSells: any;
  fees: any;
  type: any;
  isSubprime: boolean;
  isFixedYield: boolean;
  isProofOfRight: boolean;
  isTransferred: boolean;
  isOnlySellMinNotSellAll: boolean;
  isReconcileByTransferAmount: boolean;
  agents: any;
  isFixedInterestByAmount: any;
  endIssueAt: any;
  isDraft: any;
  status: any;
  closedBankNote: any;
  closedBankNoteHour: any;
  closedBankNoteMinute: any;
  closedOrderBookAt: any;
  closedOrderBookAtHour: any;
  closedOrderBookAtMinute: any;
  expectedReturn: any;
  managementFee: any;
  nav: number;
  holdingMin: number;
  lastYearNav: number;
  riskNumber: number;
  completeTransactionDuration: any;
  productSupervisoryBankAccount: any;
  fundType: any;
  fundTypeId: any;
  fundAssetTypeId: any;
  moneyTransferSyntax: any;
  moneyTransferSyntaxId: any;
  transactionDate: any;
  productTransactionDateList: any;
  assetAllocation1Id: any;
  assetAllocation2Id: any;
  riskLevelId: any;
  riskLevel: any;
  firstEndIssueAt: any;
  maturityAt: any;
  issuePrice: any;
  productSupervisoryBankAccountList: any;
  comment: any;
  issueValue: any;
  buyMinValue: any;
  buyMaxValue: any;
  performanceFee: number;
  transactionDates: any;
  owner: any;
  issuerTypeId: any;
  national: any;
  tradeCode: string;
  sipCode: string;
  closedOrderBookShiftDay: number;
  description: string;
  descriptionEn: string;
  listFee: any;
  customField: any;
  customValue: any;
  hsbcCode: any;
  ipoStartTime: number;
  ipoEndTime: number;
  endIPOTime: any;
  startIPOTime: any;
  endIPODate: any;
  startIPODate: any;
  surveyIpoTemplate: string;
  issueAtDate: any;
  buyCommissionFee: any;
  transferBuyCommissionFee: any;
  trailerFee: any;
  allocationDuration: number;
  constructor(
    params?: any
  ) {
    this.id = 0;
    this.code = '';
    this.name = '';
    this.nameEn = '';
    this.shortName = '';
    this.vsdFeeId = '';
    this.price = 0;
    this.approveAt = null;
    this.releaseAt = null;
    this.expireAt = 0;
    this.closeAt = 0;
    this.buyMin = 0;
    this.buyMax = 0;
    this.sellMin = 0;
    this.transferSellMin  = 0;
    this.inStock = 0;
    this.releaseVolume = 0;
    this.website = null;
    this.firebaseKey = null;
    this.createAt = 0;
    this.updateAt = 0;
    this.riskNumber = 1;
    this.productInfo = new ProductInfo(params.productInfo);
    this.currencyCode = null;
    this.statusCode = null;
    this.typeCode = null;
    this.countryCode = null;
    this.productFeeList = [];
    this.extra = {};
    this.featured = false;
    this.bankAccount = {};
    this.tradeCode = '';
    this.sipCode = '';
    this.feeBuys = [];
    this.feeSells = [];
    this.fees = [];
    this.type = null;
    this.isSubprime = false;
    this.isFixedYield = false;
    this.isProofOfRight = false;
    this.isTransferred = false;
    this.agents = [];
    this.isFixedInterestByAmount = false;
    this.isOnlySellMinNotSellAll = false;
    this.isReconcileByTransferAmount = false;
    this.isDraft = false;
    this.status = '';
    this.closedBankNote = '';
    this.closedOrderBookAt = '';
    this.expectedReturn = 0;
    this.managementFee = 0;
    this.buyCommissionFee = 0;
    this.transferBuyCommissionFee = 0;
    this.trailerFee = 0;
    this.nav = 0;
    this.holdingMin = 0;
    this.lastYearNav = 0;
    this.completeTransactionDuration = '';
    this.productSupervisoryBankAccount = {};
    this.fundType = '';
    this.fundTypeId = '';
    this.fundAssetTypeId = 0;
    this.moneyTransferSyntax = {};
    this.moneyTransferSyntaxId = 0;
    this.transactionDate = {};
    this.productTransactionDateList = [];
    this.assetAllocation1Id = null;
    this.assetAllocation2Id = null;
    this.productFund = null;
    this.riskLevelId = 0;
    this.riskLevel = {};
    this.issuePrice = 0;
    this.productSupervisoryBankAccountList = [];
    this.comment = '';
    this.issueValue = 0;
    this.buyMinValue = 0;
    this.buyMaxValue = 0;
    this.performanceFee = 0;
    this.transactionDates = [];
    this.endIssueAt = params.endIssueAt ?  new Date(params.endIssueAt) : null;
    this.firstEndIssueAt = params.firstEndIssueAt ?  new Date(params.firstEndIssueAt) : null;
    this.maturityAt = params.maturityAt ?  new Date(params.maturityAt) : null;
    this.owner = null;;
    this.issuerTypeId = null;;
    this.national = null;;
    this.closedOrderBookShiftDay = 0;
    this.description = '';
    this.descriptionEn = '';
    this.listFee = [];
    this.customField = '';
    this.customValue = '';
    this.hsbcCode = '';
    this.ipoStartTime = 0;
    this.ipoEndTime = 0;
    this.endIPOTime = null;
    this.startIPOTime = null;
    this.endIPODate = null;
    this.startIPODate = null;
    this.surveyIpoTemplate = '';
    this.issueAtDate = null;
    this.allocationDuration  = null;
  }
  initProduct(product) {
    this.bankAccount = this.productSupervisoryBankAccountList[0] || {};
    this.type = product.typeId;
    this.status = product.statusId;
    this.riskLevel = product.riskLevelId;
    this.owner = product.ownerId;
    this.issuerTypeId = product.issuerTypeId;
    this.national = product.nationalId;
    this.fundTypeId = (this.fundTypeId || {}).id;
    this.fundAssetTypeId = (this.fundAssetTypeId || {}).id || -1;
    if (product.assetAllocation1) {
      this.assetAllocation1Id = product.assetAllocation1.id;
    }
    if (product.assetAllocation2) {
      this.assetAllocation2Id = product.assetAllocation2.id;
    }
    this.transactionDates = this.productTransactionDateList;
    this.riskLevelId = this.riskLevel ? this.riskLevel.id : undefined;
    this.issuePrice = this.price;
  }
}
